module.exports = __webpack_public_path__ + "img/2019091801.3c133a5b.jpg";